import { useCallback, useMemo } from 'react';
import { MessageDescriptor } from 'react-intl';
import walletPagePerformanceSectionMessages from '../../../messages/wallet/wallet-page-performance-section.messages';
import { PerformanceFilter } from '../../../model';
import {
  getCurrentState,
  getSelectedWalletSection,
  myWalletSliceActions,
  retrieveProductsPerformances,
  sharedAccountsSliceActions,
} from '../../../store/features/wallet';
import { useAppDispatch, useAppSelector } from '../../redux';

export const performanceFilterCategoriesMap: Record<string, MessageDescriptor> =
  {
    Managed: walletPagePerformanceSectionMessages.managedInsuranceFinancialItem,
    Administered: walletPagePerformanceSectionMessages.administeredItem,
    RealEconomy: walletPagePerformanceSectionMessages.realEconomyItem,
    Welfare: walletPagePerformanceSectionMessages.retirementItem,
  };

export interface MyWalletPerformanceFilterLogic {
  flagOpenDateFilter: boolean;
  performanceFilter: PerformanceFilter;

  onToggleDateFilter: (forceValue?: boolean) => void;
  onPerformanceFilterChange: (filter: PerformanceFilter) => void;
}

export const useMyWalletPerformanceFilterLogic =
  (): MyWalletPerformanceFilterLogic => {
    const dispatch = useAppDispatch();

    const { performanceFilter, flagOpenDateFilter }:any =
      useAppSelector(getCurrentState);
    const selectedWalletSection = useAppSelector(getSelectedWalletSection);

    const actions = useMemo(
      () =>
        selectedWalletSection === 'MY_WALLET'
          ? myWalletSliceActions
          : sharedAccountsSliceActions,
      [selectedWalletSection]
    );

    const onPerformanceFilterChange = useCallback(
      (filter: PerformanceFilter) => {
        dispatch(actions.setPerformanceFilter(filter));
        dispatch(retrieveProductsPerformances());
      },
      [dispatch, actions]
    );

    const onToggleDateFilter = useCallback(
      (forceValue?: boolean) => {
        dispatch(
          actions.setDateFilterOpened(
            forceValue !== undefined ? forceValue : !flagOpenDateFilter
          )
        );
      },
      [dispatch, flagOpenDateFilter, actions]
    );

    return {
      flagOpenDateFilter,
      performanceFilter,
      onPerformanceFilterChange,
      onToggleDateFilter,
    };
  };
